import { useEffect, useState } from 'react';

/**
 * Renvoie le nombre de secondes restantes avant `untilMs` (timestamp epoch).
 * Retourne 0 quand le délai est écoulé. Re-render toutes les secondes tant qu'> 0.
 */
export function useCountdownSeconds(untilMs: number): number {
  const compute = () => Math.max(0, Math.ceil((untilMs - Date.now()) / 1000));
  const [seconds, setSeconds] = useState(compute);

  useEffect(() => {
    setSeconds(compute());
    if (untilMs <= Date.now()) return;
    const t = setInterval(() => {
      const next = compute();
      setSeconds(next);
      if (next <= 0) clearInterval(t);
    }, 500);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [untilMs]);

  return seconds;
}
